export const CRYSTALS = {
  AMOUNT_100: 'crystals_100',
  AMOUNT_300: 'crystals_300',
  AMOUNT_500: 'crystals_500',
  AMOUNT_1000: 'crystals_1000',
  AMOUNT_5000: 'crystals_5000',
}